<!-- 未来网盘 -->
<template>
  <div class="fature-palte" v-loading="loading" element-loading-text="网盘载入中..." element-loading-spinner="el-icon-loading">
    <iframe id="iframe" :src="src" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>
<script>
// import { checkWp } from '@/resource/api'
export default {
  /* beforeRouteEnter (to, from, next) {
    checkWp().then(() => {
      next()
    }).catch(() => {
      next()
    })
  }, */
  data () {
    return {
      loading: true,
      src: process.env.VUE_APP_WP_API
    }
  },
  mounted () {
    const iframe = document.getElementById('iframe')
    const that = this
    if (iframe.attachEvent) {
      iframe.attachEvent('onload', function () { // IE
        that.loading = false
      })
    } else {
      iframe.onload = function () { // 非IE
        that.loading = false
      }
    }
    // window.addEventListener('message', this.getMessage)
  },
  methods: {
    getMessage (e) {
      console.log(e, '###############')
    }
  }
}
</script>
<style lang="less" scoped>
.fature-palte {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
}
</style>
